module.exports = __webpack_public_path__ + "static/media/undraw_shared_goals_3d12.d10c9a54.svg";